module.exports = __webpack_public_path__ + "assets/9a5e3a43e41c4066a7013161524c4a92.mp3";